// extracted by mini-css-extract-plugin
export default {"headingDefault":"Heading_headingDefault__S8Ef+","subheading":"Heading_subheading__4lWjn"};